export function anchorScroll() {
    const offsetEl = document.querySelector('.header-offset');

    document.querySelectorAll('a[href^="#"]').forEach(link => {
        link.addEventListener('click', e => {
            const target = document.querySelector(link.getAttribute('href'));
            if (!target) return;

            e.preventDefault();

            const raw = getComputedStyle(offsetEl).paddingTop;
            const offset = parseFloat(raw);

            const targetPos = target.getBoundingClientRect().top + window.pageYOffset;

            window.scrollTo({
                top: targetPos - offset,
                behavior: 'smooth'
            });
        });
    });
}
